angular.module('vastdesk').controller('PodScheduleFormController', ['$scope', function ($scope) {
  $scope.selectedPodPlacementBulkActionIds = [];
  $scope.podPlacementBulkActionDisabledConditions = {
    nonDynamicSelected: false,
  };
}]);
